var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#F6931E",
    fillOpacity: 0.9,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9167 1.86084V3.71251C15.9408 4.20751 18.7917 7.86501 18.2966 11.8892C17.875 15.2258 15.2533 17.875 11.9167 18.2692V20.1025C16.9583 19.5983 20.625 15.125 20.1208 10.0833C19.7083 5.72917 16.2525 2.29167 11.9167 1.86084ZM10.0833 1.88834C8.29582 2.06251 6.59082 2.75001 5.19748 3.90501L6.50832 5.26167C7.53498 4.43667 8.77248 3.90501 10.0833 3.72167V1.88834ZM3.90498 5.19751C2.75883 6.58841 2.0535 8.2895 1.87915 10.0833H3.71248C3.88665 8.78167 4.39998 7.54417 5.21582 6.50834L3.90498 5.19751ZM14.2083 7.79167L9.73498 12.265L7.79165 10.3217L6.81998 11.2933L9.73498 14.2083L15.18 8.76334L14.2083 7.79167ZM1.88832 11.9167C2.07165 13.7133 2.77748 15.4092 3.91415 16.8025L5.21582 15.4917C4.40634 14.4555 3.89028 13.2207 3.72165 11.9167H1.88832ZM6.50832 16.8392L5.19748 18.095C6.58603 19.2525 8.28598 19.9733 10.0833 20.1667V18.3333C8.77927 18.1647 7.54452 17.6487 6.50832 16.8392Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.f7c894e08093b584fa0c3144c0d2d087.svg";
export { ForwardRef as ReactComponent };